export const DEFAULT_SEARCH_CRITERIA = {
    first: 0,
    rows: 25,
    sortField: null,
    sortOrder: null,
    baseQuery: '',
    filters: {},
};